import Link from 'next/link';
import { useRouter } from 'next/router';
import { HomeIcon, LogOutIcon, ShoppingCartIcon } from 'lucide-react';
import classNames from 'classnames';
import i18n from '@/settings/i18n';
import { useCustomerContext } from '@/lib/customer/CustomerContext';

const t = i18n.init('shared');

const AccountMenuContent = ({
  closeModal,
  isMobile,
}: {
  closeModal: () => void;
  isMobile?: boolean;
}) => {
  const router = useRouter();
  const isOrderRoute = [
    'account/orders',
    'account/[orderNumber]/return',
    'account/[orderNumber]/warrantyClaim',
    'account/[orderNumber]/help',
  ].some((route) => router.pathname.endsWith(route));

  const isAddressRoute = router.pathname.endsWith('/addresses');

  const { logout } = useCustomerContext();

  const btnClasses = `flex w-full items-center p-5 lg:hover:bg-gray-300 lg:py-3 focus:outline-none ${
    isMobile && 'focus:bg-gray-300'
  }`;

  return (
    <section
      className="flex flex-col items-start text-sm"
      id="e2e-account-dropdown"
    >
      <Link href="/account/orders" className="w-full">
        <button type="button" className={btnClasses} onClick={closeModal}>
          <ShoppingCartIcon
            className="h-5 w-5"
            strokeWidth={isOrderRoute ? 2 : 1.6}
          />
          <span
            className={classNames('ml-2', {
              'font-medium': isOrderRoute,
            })}
          >{t`My Orders`}</span>
        </button>
      </Link>
      <Link href="/account/addresses" className="w-full">
        <button className={btnClasses} onClick={closeModal}>
          <HomeIcon
            className="h-5 w-5"
            strokeWidth={isAddressRoute ? 2 : 1.6}
          />
          <span
            className={classNames('ml-2', {
              'font-medium': isAddressRoute,
            })}
          >{t`My Addresses`}</span>
        </button>
      </Link>
      <button
        className={btnClasses}
        id="e2e-account-logout"
        onClick={async () => {
          await logout();
          closeModal();
        }}
      >
        <LogOutIcon className="h-5 w-5" strokeWidth={1.6} />
        <span className="ml-2">{t`Logout`}</span>
      </button>
    </section>
  );
};

export default AccountMenuContent;
